var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAllThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "34px",
    viewBox: "0 0 32 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-thick-right",
    transform: "translate(16.000000, 9.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8 5 0 5 0 11 8 11 8 16 16 8 8 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-thick-up",
    transform: "translate(8.000000, 0.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5 8 5 16 11 16 11 8 16 8 8 0 0 8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-thick-down",
    transform: "translate(8.000000, 18.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5 8 5 0 11 0 11 8 16 8 8 16 0 8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-thick-left",
    transform: "translate(0.000000, 9.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8 11 16 11 16 5 8 5 8 0 0 8 8 16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAllThick);
export default __webpack_public_path__ + "static/media/arrow-all-thick.26a7e4e4320d23995d62724fa0696acc.svg";
export { ForwardRef as ReactComponent };